export const EXPERIMENTATION_LOADER_PHRASES = [
  'Preparing your workspace',
  'Booting up feature flagging',
  'Warming the flag resolver',
  'Materializing segments',
  'Staging the warehouse connection',
  'Organizing the metrics catalog',
  'Optimizing aggregations',
  'Arming guardrail metrics',
  'Initializing the statistics engine',
  'Calibrating sequential analysis',
  'Tuning asymptotics',
  'Preparing sufficient statistics',
  'Orchestrating workflows',
  'Drafting experimentation strategies',
  'Mapping experimentation surfaces',
  'Partitioning audience segments',
  'Reticulating splines',
] as const;
